/**
 * @class documentsUploadSidebar
 *
 */
import { Button, Col, Card, CardBody, Row } from 'reactstrap';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { createHashHistory } from 'history';
import DocumentUploadDropzone from './documentsUploadDropzone';
import MultiPicker from '../common/controls/multiPicker';
import entityComposition from '../common/classes/entityComposition';
import Icon from '../common/containers/icon';
const hashHistory = createHashHistory();
class DocumentsUploadSidebar extends Component {
  constructor(props) {
    super(props);

    // Hold the job/tag selections in the state as they are consumed here
    this.state = {
      selectedJobs: [],
      selectedDocumentTags: []
    };
    this.goToLibrary = () => hashHistory.replace('/library');
    this.makeSelectionJobs = this.makeSelection.bind(this, 'selectedJobs');
    this.makeSelectionTags = this.makeSelection.bind(this, 'selectedDocumentTags');
  }

  // Reset selected jobs and doc tags so they don't persist on navigation back
  // Load the documentTags and jobs if they aren't already loaded
  componentDidMount() {
    this.setState({
      selectedJobs: [],
      selectedDocumentTags: []
    });
    const {
      documentTagSelectDocument: {
        list = [],
        indexQuery
      },
      documentTagSelectDocumentActions
    } = this.props;
    if (list.length === 0) {
      documentTagSelectDocumentActions.serverIndex(indexQuery);
    }
  }

  // Handle selections made in the Selects and store them in state
  makeSelection(path, data) {
    this.setState({
      [path]: data
    });
  }
  render() {
    const {
      selectedJobs,
      selectedDocumentTags
    } = this.state;
    const {
      jobSelectUploadDocument,
      jobSelectUploadDocumentActions,
      documentTagSelectDocument: {
        list = []
      }
    } = this.props;
    return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardBody, {
      className: "card-heading"
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 8
    }, /*#__PURE__*/React.createElement("h3", {
      className: "t-dus-sidebar-title"
    }, "Upload PDFs")), /*#__PURE__*/React.createElement(Col, {
      sm: 4
    }, /*#__PURE__*/React.createElement(Button, {
      size: "sm",
      onClick: this.goToLibrary,
      className: "float-md-right t-dus-back"
    }, /*#__PURE__*/React.createElement(Icon, {
      glyph: "arrow-left"
    }), " Back")))), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(DocumentUploadDropzone, {
      defaultTags: selectedDocumentTags,
      defaultJobs: selectedJobs
    }), /*#__PURE__*/React.createElement(MultiPicker, {
      className: "t-select-jobs",
      label: "Default Jobs for New PDFs",
      entity: jobSelectUploadDocument,
      entityActions: jobSelectUploadDocumentActions,
      values: selectedJobs,
      labelKey: "jobNumber",
      multi: true,
      placeholder: "Select Jobs",
      onChange: this.makeSelectionJobs
    }), /*#__PURE__*/React.createElement(MultiPicker, {
      className: "t-select-document-tags",
      label: "Default Tags for New PDFs",
      options: list,
      values: selectedDocumentTags,
      multi: true,
      placeholder: "Select Document Tags",
      onChange: this.makeSelectionTags
    })));
  }
}
DocumentsUploadSidebar.propTypes = {
  jobSelectUploadDocument: PropTypes.shape({
    indexQuery: PropTypes.shape({
      initialized: PropTypes.bool
    }),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  documentTagSelectDocument: PropTypes.shape({
    indexQuery: PropTypes.shape({
      initialized: PropTypes.bool
    }),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  jobSelectUploadDocumentActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  // job redux actions
  documentTagSelectDocumentActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired // document tags redux actions
};
export { DocumentsUploadSidebar as TestDocumentsUploadSidebar };
export default entityComposition(DocumentsUploadSidebar, ['jobSelectUploadDocument', 'documentTagSelectDocument']);